<template>
  <div>
    <brand-filters
      :id.sync="payload.id"
      :name.sync="payload.name"
      @apply="getBrands(payload)"
    />
    <loading v-show="loading" />
    <v-card v-show="!loading" elevation="0" outlined>
      <v-app-bar flat elevation="0" dense color="transparent">
        <v-toolbar-title> <h4>Brands</h4> </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-app-bar>
      <v-divider></v-divider>
      <v-card-text class="pa-0" v-if="!loading">
        <template>
          <v-data-table
            :headers="headers"
            :items="brands"
            show-select
            v-model="selected"
            :server-items-length="totalItems"
            :options.sync="pagination"
            :items-per-page="pagination.rowsPerPageItems"
            @pagination="updatePagination"
            :disable-pagination="false"
            :footer-props="{
              disablePagination: false,
              disableItemsPerPage: false
            }"
            @click:row="edit($event.id)"
            class="elevation-0"
          >
            <!-- <template v-slot:header.data-table-select="{ props, on }">
              <!-- COLOR Not working when props.indeterminate is true -->
            <!-- <v-simple-checkbox
                color="primary"
                v-ripple
                v-bind="props"
                v-on="on"
              ></v-simple-checkbox>
            </template>
            <template v-slot:item.data-table-select="{ isSelected, select }">
              <v-simple-checkbox
                color="primary"
                v-ripple
                :value="isSelected"
                @input="select($event)"
              ></v-simple-checkbox>
            </template> -->
            <template slot="item" slot-scope="props">
              <tr @click="edit(props.item.id)">
                <td>
                  <v-simple-checkbox
                    color="primary"
                    v-ripple
                    @input="select($event)"
                  ></v-simple-checkbox>
                </td>
                <td class="text-left">
                  <v-avatar size="30px">
                    <img :src="props.item.logo" :alt="props.item.name" />
                  </v-avatar>
                </td>
                <td class="text-left">
                  {{ props.item.createdAt | relativeCreationDate }}
                </td>
                <td class="text-left">
                  {{ props.item.name }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </template>
        <v-divider></v-divider>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
// eslint max-nested-callbacks: ["error", 10]

import moment from "moment";
import VuemomentJS from "vue-momentjs";
import Helpers from "@/mixins/helpers";
import BrandFilters from "./BrandFilters.vue";

export default {
  components: {
    BrandFilters
  },
  mixins: [Helpers],
  filters: {
    relativeCreationDate: function(date) {
      return moment.utc(date).fromNow();
    }
  },
  data() {
    return {
      loading: true,
      selected: [],
      pagination: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: false,
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      headers: [
        {
          text: "",
          align: "left",
          sortable: false,
          value: "logo"
        },
        {
          text: "Created",
          align: "left",
          sortable: false,
          value: "id"
        },
        {
          text: "Name",
          align: "left",
          sortable: false,
          value: "name"
        },
        {
          text: "",
          value: "action",
          align: "right",
          sortable: false
        }
      ],
      payload: {
        from: 0,
        to: 10,
        id: " ",
        name: " "
      }
    };
  },
  computed: {
    brands() {
      return this.$store.state.brands.brands;
    },
    totalItems() {
      return this.$store.state.brands.totalBrands;
    }
  },
  created() {
    this.getBrands(this.payload);
  },
  methods: {
    getBrands(payload) {
      this.$store
        .dispatch("brands/LOAD_BRANDS", payload)
        .then(response => {
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          this.$swal("error", error.message, "error");
        });
    },
    updatePagination(pagination) {
      this.payload.from =
        pagination.page * pagination.itemsPerPage - pagination.itemsPerPage;
      this.payload.to =
        pagination.itemsPerPage === -1
          ? this.totalItems
          : pagination.itemsPerPage;
      this.getBrands(this.payload);
    },
    async deleteAndRefresh(id) {
      let res = await this.destroy(id);
      if (res) {
        this.payload.from =
          this.pagination.page * this.pagination.itemsPerPage -
          this.pagination.itemsPerPage;
        this.payload.to =
          this.pagination.itemsPerPage === -1
            ? this.totalItems
            : this.pagination.itemsPerPage;
        this.getBrands(this.payload);
      }
    }
  }
};
</script>
